import { useState, useEffect } from 'react';
import { getLLMModels } from '../services/api';

const CACHE_KEY = 'llm_models_cache';
const CACHE_DURATION = 60 * 1000; // 1 minute in milliseconds

const useLLMModels = () => {
  const [models, setModels] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchModels = async () => {
      try {
        // Check cache first
        const cached = localStorage.getItem(CACHE_KEY);
        if (cached) {
          const { data, timestamp } = JSON.parse(cached);
          const isExpired = Date.now() - timestamp > CACHE_DURATION;
          
          if (!isExpired) {
            setModels(data);
            setLoading(false);
            return;
          }
        }

        // Fetch fresh data if cache is missing or expired
        const response = await getLLMModels();
        
        // Update cache
        localStorage.setItem(CACHE_KEY, JSON.stringify({
          data: response,
          timestamp: Date.now()
        }));
        
        setModels(response);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchModels();
  }, []);

  return { models, loading, error };
};

export default useLLMModels; 